// What a card is on the client: a draft with the same fields the server
// stores (src/audio_cards/catalog.py) — name, model, scope, blocks, length,
// schedule — plus the icons and labels the screen needs.
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import PieChartIcon from '@mui/icons-material/PieChart';
import GroupsIcon from '@mui/icons-material/Groups';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const ICONS = {
  wallet: AccountBalanceWalletIcon, flat: TrendingFlatIcon, trend: TrendingUpIcon, money: MonetizationOnIcon,
  people: PersonAddAlt1Icon, bank: AccountBalanceIcon, star: StarRoundedIcon, swap: SwapVertIcon,
  pie: PieChartIcon, groups: GroupsIcon, board: LeaderboardIcon, sparkle: AutoAwesomeIcon,
};

export function CardIcon({ name, ...props }) {
  const Icon = ICONS[name] || AutoAwesomeIcon;
  return <Icon {...props} />;
}

/** The waveform glyph of HeyBro's voice buttons (EfdAgentChat, Client Notes). */
export function WaveIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 3V21M8 8V16M4 10V14M16 8V16M20 10V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export const FIELDS = ['scope', 'blocks', 'length', 'schedule'];

export function blankDraft(sources) {
  const models = Object.keys(sources || {});
  return {
    name: '', name_auto: true, model: models.length === 1 ? models[0] : null,
    scope: { type: null, client: null }, blocks: [], length: null, schedule: null,
  };
}

export function draftOf(card) {
  return {
    name: card.name || '', name_auto: card.name_auto !== false, model: card.model,
    scope: { type: card.scope?.type || 'book', client: card.scope?.client || null },
    blocks: (card.blocks || []).map((b) => ({ key: b.key, option: b.option })),
    length: card.length, schedule: card.schedule,
  };
}

/** Which of the four fields are still open (server: catalog.missing_fields). */
export function missingFields(draft) {
  const out = [];
  const scope = draft.scope || {};
  if (!['book', 'client'].includes(scope.type) || (scope.type === 'client' && !scope.client)) out.push('scope');
  if (!draft.blocks?.length) out.push('blocks');
  if (!draft.length) out.push('length');
  if (!draft.schedule) out.push('schedule');
  return out;
}

export const blockSpec = (catalog, key) => (catalog?.blocks || []).find((b) => b.key === key);
export const optionLabel = (catalog, key, option) =>
  blockSpec(catalog, key)?.options.find((o) => o.id === option)?.label || option;
export const scheduleLabel = (catalog, id) => (catalog?.schedules || []).find((s) => s.id === id)?.label || '';
export const lengthLabel = (catalog, id) => (catalog?.lengths || []).find((s) => s.id === id)?.label || '';
export const iconOf = (catalog, draft) => blockSpec(catalog, draft.blocks?.[0]?.key)?.icon || 'sparkle';

/** "Gesamtbuch" / "Mein Kundenbuch" / the client. */
export function areaOf(draft, sources) {
  if (draft.scope?.type === 'client') return draft.scope.client || '';
  return sources?.[draft.model]?.book_label || '';
}
